// extracted by mini-css-extract-plugin
module.exports = {"choices":"styles_choices__3kKCS","choicesHeader":"styles_choicesHeader__2aaX1","choice":"styles_choice__1QKr1","activeChoice":"styles_activeChoice__35_El"};